// extracted by mini-css-extract-plugin
export default {"pagnationList":"pagnationComponet_pagnationList__U9OHG","pageNum":"pagnationComponet_pageNum__3ta7q"};